export const groupLimit = 50;

export const defaultQueryLimit = 100; // Part of specs.bookings.members-area-lazy-load cleanup

export const queryPagingLimit = 20;
